import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

interface ComponentProps {
  variant: 'filled' | 'outlined';
  type: BadgeType;
  backgroundColor?: string;
  color?: string;
  icon?: React.ReactNode;
  onIconClick?: (e: any) => void;
  onClick?: (e: any) => void;
  className?: string;
  dataTestId?: string;
}

type BadgeClasses = {
  outlined: string;
  filled: string;
};

type Badges = Record<Exclude<BadgeType, 'custom' | 'none'>, BadgeClasses>;

export type BadgeType =
  'draft'
  | 'neutral'
  | 'processing'
  | 'positive'
  | 'warning'
  | 'loading'
  | 'unloading'
  | 'info'
  | 'custom'
  | 'none';


const badges: Badges = {
  unloading: {
    outlined: 'text-complementary-draftMedium border border-solid border-complementary-draftMedium',
    filled: 'text-content-primary bg-complementary-draftMedium',
  },
  loading: {
    outlined: 'text-complementary-processingMedium border border-solid border-complementary-processingMedium',
    filled: 'text-content-primary bg-complementary-processingMedium',
  },
  warning: {
    outlined: 'text-complementary-warning border border-solid border-complementary-warning',
    filled: 'text-content-primary bg-complementary-warningMedium',
  },
  positive: {
    outlined: 'text-complementary-success border border-solid border-complementary-success',
    filled: 'text-content-primary bg-complementary-successMedium',
  },
  processing: {
    outlined: 'text-complementary-processing border border-solid border-complementary-processing',
    filled: 'text-content-primary bg-complementary-processingMedium',
  },
  draft: {
    outlined: 'text-complementary-draft border border-solid border-complementary-draft',
    filled: 'text-content-secondary bg-complementary-draft',
  },
  neutral: {
    outlined: 'text-content-primary border border-solid border-content-primary',
    filled: 'text-base-secondary bg-content-secondary',
  },
  info: {
    outlined: 'text-content-primary border border-solid border-content-brandMedium bg-base-secondary',
    filled: '',
  },
};

const COBadge: React.FC<PropsWithChildren<ComponentProps>> = ({
                                                                children,
                                                                variant,
                                                                type,
                                                                backgroundColor,
                                                                color,
                                                                icon,
                                                                onIconClick,
                                                                onClick,
                                                                className,
                                                                dataTestId,
                                                              }) => {

  const clickable = !!(onClick || onIconClick);

  let badgeClass = '';
  if (type !== 'custom' && type !== 'none') {
    badgeClass = badges[type][variant];
  }

  return (
    <div
      data-testid={dataTestId}
      style={{ backgroundColor, color }}
      className={clsx(
        'inline-flex rounded  self-start gap-4 justify-start items-center',
        'font-dm-sans text-[14px] font-medium leading-none tracking-[-0.14px]',
        type !== 'none' ? 'px-2 py-1' : '',
        clickable ? 'cursor-pointer' : 'cursor-default',
        badgeClass,
        className,
      )}
      onClick={onClick}
    >
      {children}
      {icon && <div onClick={onIconClick}>{icon}</div>}
    </div>
  )
};

export default COBadge;
